import script from "./potentialsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./potentialsList.vue?vue&type=script&setup=true&lang=ts"

import "./potentialsList.vue?vue&type=style&index=0&id=6079e64e&lang=scss"

const __exports__ = script;

export default __exports__